import { UserCircle } from "@phosphor-icons/react";

// Super Admin "Global Overview": all projects grouped by the user who created them.
export const OwnersGrid = ({ owners, onOpen }) => (
  <div className="space-y-3">
    <p className="overline" data-testid="global-overview-label">Global Overview - projects by user</p>
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3" data-testid="owners-grid">
      {owners.map((o) => (
        <button key={o.id} data-testid={`owner-${o.id}`} onClick={() => onOpen(o)}
          className="text-left bg-card border border-border rounded-xl px-5 py-4 hover:border-primary hover:shadow-sm transition-all flex items-center gap-3 group">
          <div className="h-10 w-10 rounded-full bg-primary/10 grid place-items-center shrink-0">
            <UserCircle size={22} className="text-primary" weight="fill" />
          </div>
          <div className="min-w-0 flex-1">
            <div className="font-semibold truncate group-hover:text-primary transition-colors">{o.name}</div>
            <div className="text-xs text-muted-foreground">
              {o.items.length} project{o.items.length === 1 ? "" : "s"} · {o.folderCount} folder{o.folderCount === 1 ? "" : "s"}
            </div>
          </div>
        </button>
      ))}
    </div>
  </div>
);
